/* unplugin-vue-components disabled */import { render } from "./SpeachTable.vue?vue&type=template&id=4747d4c3&scoped=true&ts=true"
import script from "./SpeachTable.vue?vue&type=script&lang=ts"
export * from "./SpeachTable.vue?vue&type=script&lang=ts"

import "./SpeachTable.vue?vue&type=style&index=0&id=4747d4c3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4747d4c3"]])

export default __exports__